// extracted by mini-css-extract-plugin
export var actionText = "_ps-4";
export var container = "_ps-0";
export var leftSection = "_ps-1";
export var rightSection = "_ps-2";
export var settingsButton = "_ps-6";
export var settingsIcon = "_ps-7";
export var shortcut = "_ps-5";
export var shortcutGroup = "_ps-3";